import { render, staticRenderFns } from "./InventoryPowerUser.vue?vue&type=template&id=f133bd9a&scoped=true"
import script from "./InventoryPowerUser.vue?vue&type=script&lang=js"
export * from "./InventoryPowerUser.vue?vue&type=script&lang=js"
import style0 from "./InventoryPowerUser.vue?vue&type=style&index=0&id=f133bd9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f133bd9a",
  null
  
)

export default component.exports